
import { Store, TrendingUp, ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import { useDealerStats } from "@/hooks/dealers/useDealerStats";
import { useEffect, useState } from "react";

export function StatsSection() {
  const { getVerifiedCount, loading } = useDealerStats();
  const [prefetchedStats, setPrefetchedStats] = useState<any>(null);

  // Check for prefetched dealer statistics from SSR
  useEffect(() => {
    if (typeof window !== 'undefined' && (window as any).__DEALER_STATS) {
      setPrefetchedStats((window as any).__DEALER_STATS);
    }
  }, []);

  // Use prefetched data if available, otherwise use the hook data
  const verifiedCount = prefetchedStats?.verifiedDealers || getVerifiedCount();
  const isLoading = !prefetchedStats && loading;
  return (
    <motion.div 
      className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-12"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.4, duration: 0.7 }}
    >
      <motion.div 
        className="stats-card group hover:scale-[1.03] transition-all duration-300 border-gold/20 hover:border-gold/70 shadow-lg hover:shadow-gold/10"
        whileHover={{ y: -5 }}
      >
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold/60 to-transparent rounded-t-lg"></div>
        <p className="text-sm text-muted-foreground mb-2 flex items-center">
          <Store className="h-4 w-4 mr-2 opacity-70 group-hover:text-gold transition-colors" />
          Compro Oro
        </p>
        <p className="text-2xl font-bold text-gold">
          {isLoading ? `${verifiedCount} Verificati` : `${verifiedCount} Verificati`}
        </p>
      </motion.div>

      <motion.div 
        className="stats-card group hover:scale-[1.03] transition-all duration-300 border-silver/20 hover:border-silver/70 shadow-lg hover:shadow-silver/10"
        whileHover={{ y: -5 }}
      >
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-silver/60 to-transparent rounded-t-lg"></div>
        <p className="text-sm text-muted-foreground mb-2 flex items-center">
          <TrendingUp className="h-4 w-4 mr-2 opacity-70 group-hover:text-silver transition-colors" />
          Aggiornamenti
        </p>
        <p className="text-2xl font-bold text-silver">Ogni 30 sec</p>
      </motion.div>

      <motion.div 
        className="stats-card group hover:scale-[1.03] transition-all duration-300 border-gold/20 hover:border-gold/70 shadow-lg hover:shadow-gold/10"
        whileHover={{ y: -5 }}
      >
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold/60 to-transparent rounded-t-lg"></div>
        <p className="text-sm text-muted-foreground mb-2 flex items-center">
          <ArrowUpRight className="h-4 w-4 mr-2 opacity-70 group-hover:text-gold transition-colors" />
          Utenti
        </p>
        <p className="text-2xl font-bold text-gold">12K+ Attivi</p>
      </motion.div>
    </motion.div>
  );
}
